import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n\n  .ant-btn {\n    color: ",
        ";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    letter-spacing: -0.14px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-grow: 1;\n\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  line-break: anywhere;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.14px;\n\n  &,\n  dd {\n    margin-bottom: 0;\n  }\n\n  &,\n  dt {\n    color: ",
        ";\n  }\n  dt {\n    margin-right: 4px;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuthStore } from "@/lib/auth/AuthStore";
import styled from "styled-components";
import NoPadButton from "../../common/Button/NoPadButton";
const HorizontalStack = styled.div.withConfig({
    componentId: "sc-f94ffd53-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_indigo_500);
const Stack = styled.div.withConfig({
    componentId: "sc-f94ffd53-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_900);
const Message = styled.dl.withConfig({
    componentId: "sc-f94ffd53-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_500);
const BooksOrderDelivery = (param)=>{
    let { address , onClick  } = param;
    const { user  } = useAuthStore();
    return /*#__PURE__*/ _jsxs(Stack, {
        children: [
            /*#__PURE__*/ _jsxs(HorizontalStack, {
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: address.receiverName || user.address.name
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: (address === null || address === void 0 ? void 0 : address.address1) || user.address.address1
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        children: (address === null || address === void 0 ? void 0 : address.address2) || user.address.address2
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(NoPadButton, {
                        type: "text",
                        onClick: onClick,
                        children: "수정하기"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Message, {
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        children: "배송 메시지:"
                    }),
                    /*#__PURE__*/ _jsx("dd", {
                        children: (address === null || address === void 0 ? void 0 : address.message) || user.address.message
                    })
                ]
            })
        ]
    });
};
export default BooksOrderDelivery;
